export const formRedirectInfo = {
  "/download-a-brochure": [
    {
      refererId: "a47ab576-ad45-44c8-8377-fd0123287997",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=MIM&programmeTypeGroup=MIM&programmeType=DE&brochureType=Download%20a%20brochure&referPage=/masters-degrees/masters-in-management",
    },
    {
      refererId: "eabd7cda-2e29-42aa-a518-c4c19e97dce4",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=GMIM&programmeTypeGroup=MIM&programmeType=DE&brochureType=Download%20a%20brochure&referPage=/masters-degrees/global-masters-in-management",
    },
    {
      refererId: "4529b4e4-f683-4a87-abd8-444dd9a4c8d7",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=MAM&programmeTypeGroup=MAM&programmeType=DE&brochureType=Download%20a%20brochure&referPage=/masters-degrees/masters-in-analytics-and-management",
    },
    {
      refererId: "a8fab8ab-83b6-4c09-8b92-153eb312ff13",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=MFA&programmeTypeGroup=MFA&programmeType=DE&brochureType=Download%20a%20brochure&referPage=/masters-degrees/masters-in-financial-analysis",
    },
    {
      refererId: "bcbf6de6-e92d-48bd-ad85-759d27ded1a8",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=MBA&programmeTypeGroup=MBA&programmeType=DE&brochureType=Download%20a%20brochure&referPage=/masters-degrees/mba",
    },
    {
      refererId: "557e20b2-4bd4-4140-9270-3831b8753123",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=MIFFT&programmeTypeGroup=MIF&programmeType=DE&brochureType=Download%20a%20brochure&referPage=/masters-degrees/masters-in-finance-full-time",
    },
    {
      refererId: "1da04a59-6a2b-467b-916a-49a2975b8b62",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=MIFPT&programmeTypeGroup=MIF&programmeType=DE&brochureType=Download%20a%20brochure&referPage=/masters-degrees/masters-in-finance-part-time",
    },
    {
      refererId: "fb064c49-3c9d-48d7-89da-c7b1c25bb45c",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=EMBA%20London%20in-person&programmeTypeGroup=EMBA&programmeType=DE&brochureType=Download%20a%20brochure&referPage=/masters-degrees/executive-mba",
    },
    {
      refererId: "1df95e81-f621-48dc-81cf-3da327614de3",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=EMBA%20London%20in-person&programmeTypeGroup=EMBA&programmeType=DE&brochureType=Download%20a%20brochure&referPage=/masters-degrees/executive-mba",
    },
    {
      refererId: "03b5196e-0076-4bdb-8e8a-bf109f61c243",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=Sloan&programmeTypeGroup=SLOAN&programmeType=DE&brochureType=Download%20a%20brochure&referPage=/masters-degrees/sloan-masters-in-leadership-and-strategy",
    },
    {
      refererId: "222f3c64-d43f-4224-88ad-6e97a71c67d2",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=ADP&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/general-management/accelerated-development-programme",
    },
    {
      refererId: "314c3b48-480f-45f0-9f18-cbc49dc3fea6",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=SEP&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/general-management/senior-executive-programme",
    },
    {
      refererId: "859794ae-3aa3-487f-b307-a589cdd61218",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=CIM&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/certificates/certificate-in-management",
    },
    {
      refererId: "5622f1f8-ec24-46d0-8623-d6c7309e4fe0",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=NLL&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/leadership/next-level-leadership",
    },
    {
      refererId: "dbbd6f4d-d562-4d0b-b519-1f9cae05e8f1",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=HPPS&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/leadership/high-performance-people-skills-for-leaders",
    },
    {
      refererId: "9e8864b5-486b-4a56-954c-9d57b9af0709",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=LBF&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/leadership/leading-businesses-into-the-future",
    },
    {
      refererId: "65d29553-92f8-4b82-9795-ca30c8221fb5",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=LCP&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/leadership/leading-change",
    },
    {
      refererId: "02347f89-6897-49b1-a6a6-c3e6ad225046",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=LTEL&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/leadership/leading-teams-for-emerging-leaders",
    },
    {
      refererId: "666e68b3-a642-4f02-a830-768ca652a4d2",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=NISL&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/lbs-online/negotiating-and-influencing-skills-for-leaders",
    },
    {
      refererId: "db4bcdd0-3e83-467a-9998-f816008a444f",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=WIL&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/leadership/women-in-leadership",
    },
    {
      refererId: "c9a363fa-dc31-4813-a395-bce724fb161d",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=DSVC&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/strategy/developing-strategy-for-value-creation",
    },
    {
      refererId: "be219534-3947-4ac6-9ded-513b2d065c63",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=ESR&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/strategy/executing-strategy-for-results",
    },
    {
      refererId: "9e9eca05-ccea-4648-9150-dec45cf7482e",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=MDT&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/digital-transformation-and-innovation/mastering-digital-transformation",
    },
    {
      refererId: "3780cb3e-9039-4d9f-9db6-5d3939321164",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=CFM3&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/finance/financial-strategies-for-value-creation",
    },
    {
      refererId: "05b354aa-e9eb-4b63-ad2c-bc01e2a7ad65",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=PEN&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/finance/private-equity-negotiations",
    },
    {
      refererId: "16813368-baa4-48fe-b736-042df0d0f1b1",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=HRST&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/strategy/hr-strategy-in-transforming-organisations",
    },
    {
      refererId: "24f820e2-afb0-4fe4-9cfd-eb5c18852405",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=MA&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/strategy/mergers-and-acquisitions",
    },
    {
      refererId: "4ccb779b-aedd-4cca-9ae8-a13f30aa6571",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=SB&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/marketing/strategic-branding",
    },
    {
      refererId: "79b41d2f-0a08-4592-a12e-f6db8bbfb477",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=CFM1&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/finance/accounting-and-financial-analysis",
    },
    {
      refererId: "d7ab1018-405c-4af9-ac69-93443c71e719",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=FEB&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/finance/financing-the-entrepreneurial-business",
    },
    {
      refererId: "535586ee-a1ae-431f-a3c5-947bf463f60a",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=FNFE&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/finance/finance-for-non-finance-executives",
    },
    {
      refererId: "bfb2644c-d878-48c1-aa71-bb73e3cd8023",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=PE&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/finance/masterclass-in-private-equity",
    },
    {
      refererId: "b077238e-6a2c-4310-baf9-8579727ba29e",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=PF&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/finance/project-and-infrastructure-finance",
    },
    {
      refererId: "c03cbfb4-8ffb-4d74-ac0f-226e9f05ba86",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=SIM&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/finance/strategic-investment-management",
    },
    {
      refererId: "514bd4f8-c3ff-4f0c-b459-9ac083f4bdf8",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=CFM2&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/finance/valuation",
    },
    {
      refererId: "958cb52f-0e58-4f7d-acc1-5eb9d4270569",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=CiF&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/certificates/certificate-in-finance",
    },
    {
      refererId: "0345a605-c459-48be-bafb-f877f3d9f303",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=DSBI&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/digital-transformation-and-innovation/data-science-for-business-intelligence",
    },
    {
      refererId: "da8d28b1-f5e4-4bf4-837d-9ff56fd7d3ac",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=IDW&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/lbs-online/innovation-through-design-thinking",
    },
    {
      refererId: "8398c646-0a5f-4b3d-8a54-c340213699d0",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=NGDS&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/digital-transformation-and-innovation/next-generation-digital-strategy",
    },
    {
      refererId: "74807cb1-af5d-4e76-9618-4b70890992f2",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=LDT&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/lbs-online/leading-digital-transformation",
    },
    {
      refererId: "2e2e1ef0-0a23-484b-846f-35ee4d983bab",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=SLCR&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/lbs-online/sustainability-leadership-and-corporate-responsibility",
    },
    {
      refererId: "58fa3fac-c2b8-4f9a-8d4c-83c8c0794ea5",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=ESG&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/lbs-online/esg-investing",
    },
    {
      refererId: "62c16211-a685-4298-9eb4-9dad36090f64",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=BAI&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/lbs-online/the-business-of-ai",
    },
    {
      refererId: "d4e4127f-e6c2-4f32-be1f-235bbd75f834",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=WIB&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/lbs-online/women-in-business",
    },
    {
      refererId: "be04da18-24f1-4f54-933d-1f92c2059188",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=FNFEDUB&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/courses-in-dubai/finance-for-non-finance-executives",
    },
    {
      refererId: "25cb0fae-e27d-42d0-9e34-ea75b8609803",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=LTELDUB&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/courses-in-dubai/leading-teams-for-emerging-leaders",
    },
    {
      refererId: "5c68cf98-b668-4104-9c81-f88373823db6",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=ESRDUB&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/courses-in-dubai/executing-strategy-for-results",
    },
    {
      refererId: "9f3a2fdf-6a64-43e6-af02-a1d656ed79b6",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=MADUB&programmeTypeGroup=EXECED&programType=DE&brochureType=Download%20a%20brochure&referPage=/executive-education/courses-in-dubai/mergers-and-acquisitions",
    },
    {
      refererId: "c25caa91-854b-46fd-aeb8-ba434edbf365",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=NLLDUB&programmeTypeGroup=EXECED&programType=EE&brochureType=Download%20a%20brochure&referPage=/executive-education/courses-in-dubai/next-level-leadership",
    },
  ],
  "/submit-cv": [
    {
      refererId: "a47ab576-ad45-44c8-8377-fd0123287997",
      redirectUrl:
        "/submit-cv?programmeTypeCode=MIM&programmeTypeGroup=MIM&programmeType=DE&referPage=/masters-degrees/masters-in-management",
    },
    {
      refererId: "eabd7cda-2e29-42aa-a518-c4c19e97dce4",
      redirectUrl:
        "/submit-cv?programmeTypeCode=GMIM&programmeTypeGroup=MIM&programmeType=DE&referPage=/masters-degrees/global-masters-in-management",
    },
    {
      refererId: "4529b4e4-f683-4a87-abd8-444dd9a4c8d7",
      redirectUrl:
        "/submit-cv?programmeTypeCode=MAM&programmeTypeGroup=MAM&programmeType=DE&referPage=/masters-degrees/masters-in-analytics-and-management",
    },
    {
      refererId: "a8fab8ab-83b6-4c09-8b92-153eb312ff13",
      redirectUrl:
        "/submit-cv?programmeTypeCode=MFA&programmeTypeGroup=MFA&programmeType=DE&referPage=/masters-degrees/masters-in-financial-analysis",
    },
    {
      refererId: "bcbf6de6-e92d-48bd-ad85-759d27ded1a8",
      redirectUrl:
        "/submit-cv?programmeTypeCode=MBA&programmeTypeGroup=MBA&programmeType=DE&referPage=/masters-degrees/mba",
    },
    {
      refererId: "557e20b2-4bd4-4140-9270-3831b8753123",
      redirectUrl:
        "/submit-cv?programmeTypeCode=MIFFT&programmeTypeGroup=MIF&programmeType=DE&referPage=/masters-degrees/masters-in-finance-full-time",
    },
    {
      refererId: "1da04a59-6a2b-467b-916a-49a2975b8b62",
      redirectUrl:
        "/submit-cv?programmeTypeCode=MIFPT&programmeTypeGroup=MIF&programmeType=DE&referPage=/masters-degrees/masters-in-finance-part-time",
    },
    {
      refererId: "fb064c49-3c9d-48d7-89da-c7b1c25bb45c",
      redirectUrl:
        "/submit-cv?programmeTypeCode=EMBA%20London%20in-person&programmeTypeGroup=EMBA&programmeType=DE&referPage=/masters-degrees/executive-mba",
    },
    {
      refererId: "1df95e81-f621-48dc-81cf-3da327614de3",
      redirectUrl:
        "/submit-cv?programmeTypeCode=EMBA%20London%20in-person&programmeTypeGroup=EMBA&programmeType=DE&referPage=/masters-degrees/executive-mba",
    },
    {
      refererId: "03b5196e-0076-4bdb-8e8a-bf109f61c243",
      redirectUrl:
        "/submit-cv?programmeTypeCode=SLOAN&programmeTypeGroup=SLOAN&programmeType=DE&referPage=/masters-degrees/sloan-masters-in-leadership-and-strategy",
    },
  ],
  "/download-an-employment-report": [
    {
      refererId: "a47ab576-ad45-44c8-8377-fd0123287997",
      redirectUrl:
        "/download-an-employment-report?programmeTypeCode=MIM&programmeTypeGroup=MIM&programType=DE&brochureType=employment%20report&referPage=/masters-degrees/masters-in-management",
    },
    {
      refererId: "eabd7cda-2e29-42aa-a518-c4c19e97dce4",
      redirectUrl:
        "/download-an-employment-report?programmeTypeCode=GMIM&programmeTypeGroup=MIM&programType=DE&brochureType=employment%20report&referPage=/masters-degrees/global-masters-in-management",
    },
    {
      refererId: "4529b4e4-f683-4a87-abd8-444dd9a4c8d7",
      redirectUrl:
        "/download-an-employment-report?programmeTypeCode=MAM&programmeTypeGroup=MAM&programType=DE&brochureType=employment%20report&referPage=/masters-degrees/masters-in-analytics-and-management",
    },
    {
      refererId: "a8fab8ab-83b6-4c09-8b92-153eb312ff13",
      redirectUrl:
        "/download-an-employment-report?programmeTypeCode=MFA&programmeTypeGroup=MFA&programType=DE&brochureType=employment%20report&referPage=/masters-degrees/masters-in-financial-analysis",
    },
    {
      refererId: "bcbf6de6-e92d-48bd-ad85-759d27ded1a8",
      redirectUrl:
        "/download-an-employment-report?programmeTypeCode=MBA&programmeTypeGroup=MBA&programType=DE&brochureType=employment%20report&referPage=/masters-degrees/mba",
    },
    {
      refererId: "557e20b2-4bd4-4140-9270-3831b8753123",
      redirectUrl:
        "/download-an-employment-report?programmeTypeCode=MIFFT&programmeTypeGroup=MIF&programType=DE&brochureType=employment%20report&referPage=/masters-degrees/masters-in-finance-full-time",
    },
  ],
  "/apply": [
    {
      refererId: "a47ab576-ad45-44c8-8377-fd0123287997",
      redirectUrl: "/apply?applyID=110",
    },
    {
      refererId: "eabd7cda-2e29-42aa-a518-c4c19e97dce4",
      redirectUrl: "/apply?applyID=146",
    },
    {
      refererId: "4529b4e4-f683-4a87-abd8-444dd9a4c8d7",
      redirectUrl: "/apply?applyID=148",
    },
    {
      refererId: "a8fab8ab-83b6-4c09-8b92-153eb312ff13",
      redirectUrl: "/apply?applyID=137",
    },
    {
      refererId: "bcbf6de6-e92d-48bd-ad85-759d27ded1a8",
      redirectUrl: "/apply?applyID=38",
    },
    {
      refererId: "557e20b2-4bd4-4140-9270-3831b8753123",
      redirectUrl: "/apply?applyID=5",
    },
    {
      refererId: "1da04a59-6a2b-467b-916a-49a2975b8b62",
      redirectUrl: "/apply?applyID=59",
    },
    {
      refererId: "b9826bb3-5f4d-45a6-8f6a-6d2dfc018411",
      redirectUrl: "/embag/apply?applyID=3",
    },
    {
      refererId: "fb064c49-3c9d-48d7-89da-c7b1c25bb45c",
      redirectUrl: "/apply?applyID=2",
    },
    {
      refererId: "1df95e81-f621-48dc-81cf-3da327614de3",
      redirectUrl: "/apply?applyID=145",
    },
    {
      refererId: "03b5196e-0076-4bdb-8e8a-bf109f61c243",
      redirectUrl: "/apply?applyID=4",
    },
    {
      refererId: "222f3c64-d43f-4224-88ad-6e97a71c67d2",
      redirectUrl: "/apply?&applyID=9",
    },
    {
      refererId: "314c3b48-480f-45f0-9f18-cbc49dc3fea6",
      redirectUrl: "/apply?&applyID=8",
    },
    {
      refererId: "5622f1f8-ec24-46d0-8623-d6c7309e4fe0",
      redirectUrl: "/apply?&applyID=168",
    },
    {
      refererId: "dbbd6f4d-d562-4d0b-b519-1f9cae05e8f1",
      redirectUrl: "/apply?&applyID=16",
    },
    {
      refererId: "9e8864b5-486b-4a56-954c-9d57b9af0709",
      redirectUrl: "/apply?&applyID=132",
    },
    {
      refererId: "65d29553-92f8-4b82-9795-ca30c8221fb5",
      redirectUrl: "/apply?&applyID=128",
    },
    {
      refererId: "02347f89-6897-49b1-a6a6-c3e6ad225046",
      redirectUrl: "/apply?&applyID=134",
    },
    {
      refererId: "666e68b3-a642-4f02-a830-768ca652a4d2",
      redirectUrl: "/apply?&applyID=151",
    },
    {
      refererId: "db4bcdd0-3e83-467a-9998-f816008a444f",
      redirectUrl: "/apply?&applyID=152",
    },
    {
      refererId: "c9a363fa-dc31-4813-a395-bce724fb161d",
      redirectUrl: "/apply?&applyID=41",
    },
    {
      refererId: "be219534-3947-4ac6-9ded-513b2d065c63",
      redirectUrl: "/apply?&applyID=73",
    },
    {
      refererId: "9e9eca05-ccea-4648-9150-dec45cf7482e",
      redirectUrl: "/apply?&applyID=177",
    },
    {
      refererId: "3780cb3e-9039-4d9f-9db6-5d3939321164",
      redirectUrl: "/apply?&applyID=122",
    },
    {
      refererId: "05b354aa-e9eb-4b63-ad2c-bc01e2a7ad65",
      redirectUrl: "/apply?&applyID=172",
    },
    {
      refererId: "16813368-baa4-48fe-b736-042df0d0f1b1",
      redirectUrl: "/apply?&applyID=17",
    },
    {
      refererId: "24f820e2-afb0-4fe4-9cfd-eb5c18852405",
      redirectUrl: "/apply?&applyID=42",
    },
    {
      refererId: "4ccb779b-aedd-4cca-9ae8-a13f30aa6571",
      redirectUrl: "/apply?&applyID=60",
    },
    {
      refererId: "79b41d2f-0a08-4592-a12e-f6db8bbfb477",
      redirectUrl: "/apply?&applyID=120",
    },
    {
      refererId: "d7ab1018-405c-4af9-ac69-93443c71e719",
      redirectUrl: "/apply?&applyID=64",
    },
    {
      refererId: "535586ee-a1ae-431f-a3c5-947bf463f60a",
      redirectUrl: "/apply?&applyID=142",
    },
    {
      refererId: "bfb2644c-d878-48c1-aa71-bb73e3cd8023",
      redirectUrl: "/apply?&applyID=92",
    },
    {
      refererId: "b077238e-6a2c-4310-baf9-8579727ba29e",
      redirectUrl: "/apply?&applyID=126",
    },
    {
      refererId: "c03cbfb4-8ffb-4d74-ac0f-226e9f05ba86",
      redirectUrl: "/apply?&applyID=127",
    },
    {
      refererId: "514bd4f8-c3ff-4f0c-b459-9ac083f4bdf8",
      redirectUrl: "/apply?&applyID=121",
    },
    {
      refererId: "0345a605-c459-48be-bafb-f877f3d9f303",
      redirectUrl: "/apply?&applyID=155",
    },
    {
      refererId: "da8d28b1-f5e4-4bf4-837d-9ff56fd7d3ac",
      redirectUrl: "/apply?&applyID=147",
    },
    {
      refererId: "8398c646-0a5f-4b3d-8a54-c340213699d0",
      redirectUrl: "/apply?&applyID=171",
    },
    {
      refererId: "74807cb1-af5d-4e76-9618-4b70890992f2",
      redirectUrl: "/apply?&applyID=170",
    },
    {
      refererId: "2e2e1ef0-0a23-484b-846f-35ee4d983bab",
      redirectUrl: "/apply?&applyID=154",
    },
    {
      refererId: "58fa3fac-c2b8-4f9a-8d4c-83c8c0794ea5",
      redirectUrl: "/apply?&applyID=176",
    },
    {
      refererId: "62c16211-a685-4298-9eb4-9dad36090f64",
      redirectUrl: "/apply?&applyID=169",
    },
    {
      refererId: "d4e4127f-e6c2-4f32-be1f-235bbd75f834",
      redirectUrl: "/apply?&applyID=164",
    },
    {
      refererId: "be04da18-24f1-4f54-933d-1f92c2059188",
      redirectUrl: "/apply?&applyID=178",
    },
    {
      refererId: "25cb0fae-e27d-42d0-9e34-ea75b8609803",
      redirectUrl: "/apply?&applyID=134",
    },
    {
      refererId: "5c68cf98-b668-4104-9c81-f88373823db6",
      redirectUrl: "/apply?&applyID=73",
    },
    {
      refererId: "9f3a2fdf-6a64-43e6-af02-a1d656ed79b6",
      redirectUrl: "/apply?&applyID=181",
    },
    {
      refererId: "c25caa91-854b-46fd-aeb8-ba434edbf365",
      redirectUrl: "/apply?&applyID=168",
    },
  ],
  "/embag/embag-submit-cv": [
    {
      refererId: "B9826BB3-5F4D-45A6-8F6A-6D2DFC018411",
      redirectUrl:
        "/embag/embag-submit-cv?programmeTypeCode=EMBAG&programmeTypeGroup=EMBAG",
    },
  ],
  "/embag/embag-download-a-brochure": [
    {
      refererId: "B9826BB3-5F4D-45A6-8F6A-6D2DFC018411",
      redirectUrl:
        "/embag/embag-download-a-brochure?programmeTypeCode=EMBAG&programmeTypeGroup=EMBAG&brochureType=Download%20a%20brochure",
    },
  ],
  "/forms/download-a-brochure": [
    {
      refererId: "fb064c49-3c9d-48d7-89da-c7b1c25bb45c",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=EMBA%20London%20in-person&programmeTypeGroup=EMBA&programmeType=DE&brochureType=Download%20a%20brochure&referPage=/masters-degrees/executive-mba",
    },
    {
      refererId: "1df95e81-f621-48dc-81cf-3da327614de3",
      redirectUrl:
        "/download-a-brochure?programmeTypeCode=EMBA%20London%20in-person&programmeTypeGroup=EMBA&programmeType=DE&brochureType=Download%20a%20brochure&referPage=/masters-degrees/executive-mba",
    },
  ],
  "/reserve-a-place": [
    {
      refererId: "222f3c64-d43f-4224-88ad-6e97a71c67d2",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=ADP&programmeTypeGroup=EXECED&referPage=/executive-education/general-management/accelerated-development-programme",
    },
    {
      refererId: "314c3b48-480f-45f0-9f18-cbc49dc3fea6",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=SEP&programmeTypeGroup=EXECED&referPage=/executive-education/general-management/senior-executive-programme",
    },
    {
      refererId: "5622f1f8-ec24-46d0-8623-d6c7309e4fe0",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=NLL&programmeTypeGroup=EXECED&referPage=/executive-education/leadership/next-level-leadership",
    },
    {
      refererId: "dbbd6f4d-d562-4d0b-b519-1f9cae05e8f1",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=HPPS&programmeTypeGroup=EXECED&referPage=/executive-education/leadership/high-performance-people-skills-for-leaders",
    },
    {
      refererId: "9e8864b5-486b-4a56-954c-9d57b9af0709",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=LBF&programmeTypeGroup=EXECED&referPage=/executive-education/leadership/leading-businesses-into-the-future",
    },
    {
      refererId: "65d29553-92f8-4b82-9795-ca30c8221fb5",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=LCP&programmeTypeGroup=EXECED&referPage=/executive-education/leadership/leading-change",
    },
    {
      refererId: "666e68b3-a642-4f02-a830-768ca652a4d2",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=NISL&programmeTypeGroup=EXECED&referPage=/lbs-online/negotiating-and-influencing-skills-for-leaders",
    },
    {
      refererId: "db4bcdd0-3e83-467a-9998-f816008a444f",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=WIL&programmeTypeGroup=EXECED&referPage=/executive-education/leadership/women-in-leadership",
    },
    {
      refererId: "c9a363fa-dc31-4813-a395-bce724fb161d",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=DSVC&programmeTypeGroup=EXECED&referPage=/executive-education/strategy/developing-strategy-for-value-creation",
    },
    {
      refererId: "be219534-3947-4ac6-9ded-513b2d065c63",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=ESR&programmeTypeGroup=EXECED&referPage=/executive-education/strategy/executing-strategy-for-results",
    },
    {
      refererId: "9e9eca05-ccea-4648-9150-dec45cf7482e",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=MDT&programmeTypeGroup=EXECED&referPage=/executive-education/digital-transformation-and-innovation/mastering-digital-transformation",
    },
    {
      refererId: "3780cb3e-9039-4d9f-9db6-5d3939321164",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=CFM3&programmeTypeGroup=EXECED&referPage=/executive-education/finance/financial-strategies-for-value-creation",
    },
    {
      refererId: "05b354aa-e9eb-4b63-ad2c-bc01e2a7ad65",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=PEN&programmeTypeGroup=EXECED&referPage=/executive-education/finance/private-equity-negotiations",
    },
    {
      refererId: "16813368-baa4-48fe-b736-042df0d0f1b1",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=HRST&programmeTypeGroup=EXECED&referPage=/executive-education/strategy/hr-strategy-in-transforming-organisations",
    },
    {
      refererId: "24f820e2-afb0-4fe4-9cfd-eb5c18852405",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=MA&programmeTypeGroup=EXECED&referPage=/executive-education/strategy/mergers-and-acquisitions",
    },
    {
      refererId: "4ccb779b-aedd-4cca-9ae8-a13f30aa6571",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=SB&programmeTypeGroup=EXECED&referPage=/executive-education/marketing/strategic-branding",
    },
    {
      refererId: "79b41d2f-0a08-4592-a12e-f6db8bbfb477",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=CFM1&programmeTypeGroup=EXECED&referPage=/executive-education/finance/accounting-and-financial-analysis",
    },
    {
      refererId: "d7ab1018-405c-4af9-ac69-93443c71e719",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=FEB&programmeTypeGroup=EXECED&referPage=/executive-education/finance/financing-the-entrepreneurial-business",
    },
    {
      refererId: "535586ee-a1ae-431f-a3c5-947bf463f60a",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=FNFE&programmeTypeGroup=EXECED&referPage=/executive-education/finance/finance-for-non-finance-executives",
    },
    {
      refererId: "bfb2644c-d878-48c1-aa71-bb73e3cd8023",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=PE&programmeTypeGroup=EXECED&referPage=/executive-education/finance/masterclass-in-private-equity",
    },
    {
      refererId: "b077238e-6a2c-4310-baf9-8579727ba29e",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=PF&programmeTypeGroup=EXECED&referPage=/executive-education/finance/project-and-infrastructure-finance",
    },
    {
      refererId: "c03cbfb4-8ffb-4d74-ac0f-226e9f05ba86",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=SIM&programmeTypeGroup=EXECED&referPage=/executive-education/finance/strategic-investment-management",
    },
    {
      refererId: "514bd4f8-c3ff-4f0c-b459-9ac083f4bdf8",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=CFM2&programmeTypeGroup=EXECED&referPage=/executive-education/finance/valuation",
    },
    {
      refererId: "0345a605-c459-48be-bafb-f877f3d9f303",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=DSBI&programmeTypeGroup=EXECED&referPage=/executive-education/digital-transformation-and-innovation/data-science-for-business-intelligence",
    },
    {
      refererId: "da8d28b1-f5e4-4bf4-837d-9ff56fd7d3ac",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=IDW&programmeTypeGroup=EXECED&referPage=/lbs-online/innovation-through-design-thinking",
    },
    {
      refererId: "8398c646-0a5f-4b3d-8a54-c340213699d0",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=NGDS&programmeTypeGroup=EXECED&referPage=/executive-education/digital-transformation-and-innovation/next-generation-digital-strategy",
    },
    {
      refererId: "2e2e1ef0-0a23-484b-846f-35ee4d983bab",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=SLCR&programmeTypeGroup=EXECED&referPage=/lbs-online/sustainability-leadership-and-corporate-responsibility",
    },
    {
      refererId: "58fa3fac-c2b8-4f9a-8d4c-83c8c0794ea5",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=ESG&programmeTypeGroup=EXECED&referPage=/lbs-online/esg-investing",
    },
    {
      refererId: "62c16211-a685-4298-9eb4-9dad36090f64",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=BAI&programmeTypeGroup=EXECED&referPage=/lbs-online/the-business-of-ai",
    },
    {
      refererId: "d4e4127f-e6c2-4f32-be1f-235bbd75f834",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=WIB&programmeTypeGroup=EXECED&referPage=/lbs-online/women-in-business",
    },
    {
      refererId: "be04da18-24f1-4f54-933d-1f92c2059188",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=FNFEDUB&programmeTypeGroup=EXECED&referPage=/executive-education/courses-in-dubai/finance-for-non-finance-executives",
    },
    {
      refererId: "25cb0fae-e27d-42d0-9e34-ea75b8609803",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=LTELDUB&programmeTypeGroup=EXECED&referPage=/executive-education/courses-in-dubai/leading-teams-for-emerging-leaders",
    },
    {
      refererId: "5c68cf98-b668-4104-9c81-f88373823db6",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=ESRDUB&programmeTypeGroup=EXECED&referPage=/executive-education/courses-in-dubai/executing-strategy-for-results",
    },
    {
      refererId: "9f3a2fdf-6a64-43e6-af02-a1d656ed79b6",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=MADUB&programmeTypeGroup=EXECED&referPage=/executive-education/courses-in-dubai/mergers-and-acquisitions",
    },
    {
      refererId: "c25caa91-854b-46fd-aeb8-ba434edbf365",
      redirectUrl:
        "/reserve-a-place?programmeTypeCode=NLLDUB&programmeTypeGroup=EXECED&referPage=/executive-education/courses-in-dubai/next-level-leadership",
    },
  ],
  "/forms/consultant-form": [
    {
      refererId: "222f3c64-d43f-4224-88ad-6e97a71c67d2",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=ADP&programmeType=EE&consultantName=Michal%20Kopacka&referPage=/executive-education/general-management/accelerated-development-programme",
    },
    {
      refererId: "314c3b48-480f-45f0-9f18-cbc49dc3fea6",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=SEP&programmeType=EE&consultantName=Tim%20Pearson&referPage=/executive-education/general-management/senior-executive-programme",
    },
    {
      refererId: "859794ae-3aa3-487f-b307-a589cdd61218",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=CIM&programmeType=EE&consultantName=Rampai%20Motsau&referPage=/executive-education/certificates/certificate-in-management",
    },
    {
      refererId: "5622f1f8-ec24-46d0-8623-d6c7309e4fe0",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=NLL&programmeType=EE&consultantName=Nikolaos%20Violatzis&referPage=/executive-education/leadership/next-level-leadership",
    },
    {
      refererId: "dbbd6f4d-d562-4d0b-b519-1f9cae05e8f1",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=HPPS&programmeType=EE&consultantName=Michael%20Kopacka&referPage=/executive-education/leadership/high-performance-people-skills-for-leaders",
    },
    {
      refererId: "9e8864b5-486b-4a56-954c-9d57b9af0709",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=LBF&programmeType=EE&consultantName=Tim%20Pearson&referPage=/executive-education/leadership/leading-businesses-into-the-future",
    },
    {
      refererId: "65d29553-92f8-4b82-9795-ca30c8221fb5",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=LCP&programmeType=EE&consultantName=Sonja%20Strack&referPage=/executive-education/leadership/leading-change",
    },
    {
      refererId: "02347f89-6897-49b1-a6a6-c3e6ad225046",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=LTEL&programmeType=EE&consultantName=Sonja%20Strack&referPage=/executive-education/leadership/leading-teams-for-emerging-leaders",
    },
    {
      refererId: "666e68b3-a642-4f02-a830-768ca652a4d2",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=NISL&programmeType=EE&consultantName=Sabirul%20Islam&referPage=/lbs-online/negotiating-and-influencing-skills-for-leaders",
    },
    {
      refererId: "db4bcdd0-3e83-467a-9998-f816008a444f",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=WIL&programmeType=EE&consultantName=Sonja%20Strack&referpage=/executive-education/leadership/women-in-leadership",
    },
    {
      refererId: "c9a363fa-dc31-4813-a395-bce724fb161d",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=DSVC&programmeType=EE&consultantName=Richard%20Sturdy&referpage=/executive-education/strategy/developing-strategy-for-value-creation",
    },
    {
      refererId: "be219534-3947-4ac6-9ded-513b2d065c63",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=ESR&programmeType=EE&consultantName=Richard%20Sturdy&referpage=/executive-education/strategy/executing-strategy-for-results",
    },
    {
      refererId: "9e9eca05-ccea-4648-9150-dec45cf7482e",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=MDT&programmeType=EE&consultantName=Rampai%20Motsau&referPage=/executive-education/digital-transformation-and-innovation/mastering-digital-transformation",
    },
    {
      refererId: "3780cb3e-9039-4d9f-9db6-5d3939321164",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=CFM3&programmeType=EE&consultantName=David%20Ratcliffe&referpage=/executive-education/finance/financial-strategies-for-value-creation",
    },
    {
      refererId: "05b354aa-e9eb-4b63-ad2c-bc01e2a7ad65",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=PEN&programmeType=EE&consultantName=David%20Ratcliffe&referpage=/executive-education/finance/private-equity-negotiations",
    },
    {
      refererId: "16813368-baa4-48fe-b736-042df0d0f1b1",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=HRST&programmeType=EE&consultantName=Tim%20Pearson&referpage=/executive-education/strategy/hr-strategy-in-transforming-organisations",
    },
    {
      refererId: "24f820e2-afb0-4fe4-9cfd-eb5c18852405",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=MA&programmeType=EE&consultantName=Richard%20Sturdy&referpage=/executive-education/strategy/mergers-and-acquisitions",
    },
    {
      refererId: "4ccb779b-aedd-4cca-9ae8-a13f30aa6571",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=SB&programmeType=EE&consultantName=Sabirul%20Islam&referpage=/executive-education/marketing/strategic-branding",
    },
    {
      refererId: "79b41d2f-0a08-4592-a12e-f6db8bbfb477",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=CFM1&programmeType=EE&consultantName=David%20Ratcliffe&referpage=/executive-education/finance/accounting-and-financial-analysis",
    },
    {
      refererId: "d7ab1018-405c-4af9-ac69-93443c71e719",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=FEB&programmeType=EE&consultantName=David%20Ratcliffe&referpage=/executive-education/finance/financing-the-entrepreneurial-business",
    },
    {
      refererId: "535586ee-a1ae-431f-a3c5-947bf463f60a",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=FNFE&programmeType=EE&consultantName=David%20Ratcliffe&referpage=/executive-education/finance/finance-for-non-finance-executives",
    },
    {
      refererId: "bfb2644c-d878-48c1-aa71-bb73e3cd8023",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=PE&programmeType=EE&consultantName=David%20Ratcliffe&referpage=/executive-education/finance/accounting-and-financial-analysis",
    },
    {
      refererId: "b077238e-6a2c-4310-baf9-8579727ba29e",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=PF&programmeType=EE&consultantName=David%20Ratcliffe&referpage=/executive-education/finance/project-and-infrastructure-finance",
    },
    {
      refererId: "c03cbfb4-8ffb-4d74-ac0f-226e9f05ba86",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=SIM&programmeType=EE&consultantName=Richard%20Sturdy&referPage=/executive-education/finance/strategic-investment-management",
    },
    {
      refererId: "514bd4f8-c3ff-4f0c-b459-9ac083f4bdf8",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=CFM2&programmeType=EE&consultantName=David%20Ratcliffe&referpage=/executive-education/finance/valuation",
    },
    {
      refererId: "958cb52f-0e58-4f7d-acc1-5eb9d4270569",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=CIF&programmeType=EE&consultantName=David%20Ratcliffe&referpage=/certificates/certificate-in-finance",
    },
    {
      refererId: "0345a605-c459-48be-bafb-f877f3d9f303",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=DSBI&programmeType=EE&consultantName=Rampai%20Motsau&referPage=/executive-education/digital-transformation-and-innovation/data-science-for-business-intelligence",
    },
    {
      refererId: "da8d28b1-f5e4-4bf4-837d-9ff56fd7d3ac",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=IDW&programmeType=EE&consultantName=Sabirul%20Islam&referpage=/lbs-online/innovation-through-design-thinking",
    },
    {
      refererId: "8398c646-0a5f-4b3d-8a54-c340213699d0",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=NGDS&programmeType=EE&consultantName=Rampai%20Motsau&referpage=/executive-education/digital-transformation-and-innovation/next-generation-digital-strategy",
    },
    {
      refererId: "74807cb1-af5d-4e76-9618-4b70890992f2",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=LDT&programmeType=EE&consultantName=Sabirul%20Islam&referPage=/lbs-online/leading-digital-transformation",
    },
    {
      refererId: "2e2e1ef0-0a23-484b-846f-35ee4d983bab",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=SLCR&programmeType=EE&consultantName=Sabirul%20Islam&referPage=/lbs-online/sustainability-leadership-and-corporate-responsibility",
    },
    {
      refererId: "58fa3fac-c2b8-4f9a-8d4c-83c8c0794ea5",
      redirectUrl:
        "/%E2%81%A0/forms/consultant-form?programmeTypeCode=ESG&programmeType=EE&consultantName=Sabirul%20Islam&referpage=/lbs-online/esg-investing",
    },
    {
      refererId: "14bac9d2-b0f3-4ab1-8a06-701a38290e4f",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=BAI&programmeType=EE&consultantName=Sabirul%20Islam&referpage=/lbs-online/the-business-of-ai",
    },
    {
      refererId: "d4e4127f-e6c2-4f32-be1f-235bbd75f834",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=WIB&programmeType=EE&consultantName=Sabirul%20Islam&referPage=/lbs-online/women-in-business",
    },
    {
      refererId: "be04da18-24f1-4f54-933d-1f92c2059188",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=FNFEDUB&programmeType=EE&consultantName=David%20Ratcliffe&referpage=/executive-education/courses-in-dubai/finance-for-non-finance-executives",
    },
    {
      refererId: "25cb0fae-e27d-42d0-9e34-ea75b8609803",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=LTELDUB&programmeType=EE&consultantName=Sonja%20Strack&referPage=/executive-education/courses-in-dubai/leading-teams-for-emerging-leaders",
    },
    {
      refererId: "5c68cf98-b668-4104-9c81-f88373823db6",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=ESRDUB&programmeType=EE&consultantName=Richard%20Sturdy&referpage=/executive-education/courses-in-dubai/executing-strategy-for-results",
    },
    {
      refererId: "9f3a2fdf-6a64-43e6-af02-a1d656ed79b6",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=MADUB&programmeType=EE&consultantName=Richard%20Sturdy&referpage=/executive-education/strategy/mergers-and-acquisitions",
    },
    {
      refererId: "c25caa91-854b-46fd-aeb8-ba434edbf365",
      redirectUrl:
        "/forms/consultant-form?programmeTypeCode=NLLDUB&programmeType=EE&consultantName=Nikolaos%20Violatzis&referPage=/executive-education/courses-in-dubai/next-level-leadership",
    },
  ],
};

export const findObjectByRefererId = (array, targetRefererId) => {
  return array.find((obj) => obj.refererId === targetRefererId);
};
